import React from 'react';

import {
  Row, Col, Input,
  TabPane, Card, Button,
} from 'reactstrap';

import functions from '../../../../../functions';

import imgNoDisponible from '../../../../../../public/img/image-not-found.png';
import '../styles.css';

class TabImagenes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      original: [...props.data.Imagenes],
    };
  }

  changeSizeSelected(newSize) {
    const { Imagenes } = this.props.data;
    const { onChangeField } = this.props;

    if (Imagenes.length < newSize) {
      while (Imagenes.length < newSize) {
        Imagenes.push(
          {
            src: imgNoDisponible,
            srcfull: imgNoDisponible,
            altText: 'Imagen Base',
            Talle_id: this.props.data.Talles.length > 0 ? this.props.data.Talles[0].Codigo : null,
            Color_id: this.props.data.Colores.length > 0 ? this.props.data.Colores[0].Codigo : null,
          }
        );
      }
    }
    else if (Imagenes.length > newSize) {
      while (Imagenes.length > newSize) {
        Imagenes.pop();
      }
    }

    Imagenes.forEach((item, i) => {
      item.Order = i + 1;
    });

    onChangeField('Imagenes', Imagenes);
  }

  removeItem(index) {
    const { Imagenes } = this.props.data;
    const { onChangeField } = this.props;

    if (index >= 0 && index < Imagenes.length) {
      let newImages = [];

      Imagenes.forEach((item, i) => {
        if (i != index) {
          newImages.push(item);
        }
      });

      newImages.forEach((item, i) => {
        item.Order = i + 1;
      });

      onChangeField('Imagenes', newImages);
    }
  }

  updateOrder(index, mov) {
    const { Imagenes } = this.props.data;
    const { onChangeField } = this.props;

    if ((mov == 1 || mov == -1) && index >= 0 && index < Imagenes.length) {
      let newImages = [];

      if (mov == -1) {
        let prevItem = Imagenes[index - 1];
        let item = Imagenes[index];
        Imagenes[index - 1] = item;
        Imagenes[index] = prevItem;
      }
      else if (mov == +1) {
        let nextItem = Imagenes[index + 1];
        let item = Imagenes[index];
        Imagenes[index + 1] = item;
        Imagenes[index] = nextItem;
      }
      Imagenes.forEach((item, i) => newImages.push(item));

      newImages.forEach((item, i) => {
        item.Order = i + 1;
      });

      onChangeField('Imagenes', newImages);
    }
  }

  updateImage(index, evt) {
    evt.preventDefault();

    const { Imagenes } = this.props.data;
    const { onChangeField } = this.props;

    let node = document.getElementById("raised-button-file-" + index);
    if (node != undefined && node != null && node.files != null && node.files.length == 1) {
      const reject = (Image) => {
        let newImages = [...Imagenes];
        newImages[index].src = Image;
        onChangeField('Imagenes', newImages);
      };
      const resolve = (resizedImage) => {
        let newImages = [...Imagenes];
        newImages[index].src = resizedImage;
        onChangeField('Imagenes', newImages);
      };
      //functions.resizeBase64Img(640, node.files[0]).then(resolve).catch(reject);
      functions.getB64ImageFromInputFile(node.files[0]).then(resolve).catch(reject);
    }
  }

  updateImageData(index, field, evt) {
    evt.preventDefault();
    const newImages = [...this.props.data.Imagenes];
    const { onChangeField } = this.props;
    if (index >= 0 && index < newImages.length) {
      newImages[index][field] = evt.target.value;
      onChangeField('Imagenes', newImages);
    }
  }

  render() {
    const { data, vars } = this.props;
    return (
      <TabPane tabId="2" className="modalArticuloTabContainer">
        <select value={data.Imagenes.length} className="p-2 mb-2" onChange={(evt) => this.changeSizeSelected(evt.target.value)}>
          <option value={0}>Sin Imagenes</option>
          <option value={1}>1 Imagen</option>
          <option value={2}>2 Imagenes</option>
          <option value={3}>3 Imagenes</option>
          <option value={4}>4 Imagenes</option>
          <option value={5}>5 Imagenes</option>
          <option value={6}>6 Imagenes</option>
          <option value={7}>7 Imagenes</option>
          <option value={8}>8 Imagenes</option>
          <option value={9}>9 Imagenes</option>
        </select>
        <Row>
          {
            data.Imagenes.map((item, index) => (
              <Col sm={12} md={4} className="p-1">
                <Card key={"card-" + index} body className="p-0 rounded">
                  <label htmlFor={"raised-button-file-" + index} className="m-0" title="Abrir Explorador de Archivos">
                    <div className="img-modal-novedad">
                      <img className="img-modal-novedad-holder rounded" height={225} width="100%" src={item.src} alt={"Imagen Articulo " + index} />
                    </div>
                  </label>
                  <input type="file" accept="image/*" id={"raised-button-file-" + index} name={"raised-button-file-" + index} style={{ color: "transparent" }} className={vars.disabled == true ? "d-none" : ""}
                    onChange={evt => {
                      const idx = index;
                      this.updateImage(idx, evt);
                    }}
                  />
                  <Row>
                    {
                      this.props.data.Colores && this.props.data.Colores.length > 0 &&
                      <Col xs={12} className="my-1">
                        <Input
                          type="select"
                          value={item.Color_id}
                          onChange={(evt) => {
                            const idx = index;
                            this.updateImageData(idx, 'Color_id', evt);
                          }}>
                          {
                            this.props.data.Colores.map((color, idx) => (
                              <option key={`color-${idx}`} value={color.Codigo}>{color.Nombre}</option>
                            ))
                          }
                        </Input>
                      </Col>
                    }
                    {
                      this.props.data.Talles && this.props.data.Talles.length > 0 &&
                      <Col xs={12} className="my-1">
                        <Input
                          type="select"
                          value={item.Talle_id}
                          onChange={(evt) => {
                            const idx = index;
                            this.updateImageData(idx, 'Talle_id', evt);
                          }}
                        >
                          {
                            this.props.data.Talles.map((talle, idx) => (
                              <option key={`talle-${idx}`} value={talle.Codigo}>{talle.Nombre}</option>
                            ))
                          }
                        </Input>
                      </Col>
                    }
                  </Row>
                  <Row className={vars.disabled == true ? "my-2 mx-2 text-center d-none" : "my-2 mx-2 text-center"}>
                    {
                      (index == 0 || index == (data.Imagenes.length - 1)) && <Col />
                    }
                    {
                      index > 0 && data.Imagenes.length > 1 &&
                      <Col className="px-1">
                        <Button color="success" className="w-75 rounded"
                          disabled={vars.disabled}
                          onClick={(evt) => {
                            const idx = index;
                            this.updateOrder(idx, -1);
                          }}
                        ><span className="fa fa-arrow-left" /></Button>
                      </Col>
                    }
                    {
                      index < (data.Imagenes.length - 1) && data.Imagenes.length > 1 &&
                      <Col className="px-1">
                        <Button color="success" className="w-75 rounded"
                          disabled={vars.disabled}
                          onClick={(evt) => {
                            const idx = index;
                            this.updateOrder(idx, +1);
                          }}
                        ><span className="fa fa-arrow-right" /></Button>
                      </Col>
                    }
                    <Col className="px-1">
                      <Button color="warning" className="w-75 rounded"
                        disabled={vars.disabled}
                        onClick={(evt) => {
                          const idx = index;
                          this.removeItem(idx);
                        }}
                      ><span className="fa fa-trash" /></Button>
                    </Col>
                  </Row>
                </Card>
              </Col>
            ))
          }
        </Row>
      </TabPane>
    );
  }
}
export default TabImagenes;



// WEBPACK FOOTER //
// ./src/views/Gestion/Articulos/Articulos/ModalArticulo/TabImagenes.js